import { Pipe, PipeTransform } from '@angular/core';
import { OlxPrice } from '../modules/crm/power-olx-v2/interfaces/power-olx-v2.interface';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'olxPrice',
  standalone: false,
})
export class OlxPricePipe implements PipeTransform {

  constructor(private readonly translate: TranslateService) {
  }

  transform(price?: OlxPrice): string {
    let result: string = this.translate.instant('free');

    if (price?.trade) {
      result = this.translate.instant('trade');
    } else if (price?.value) {

      result = String(price.value);

      const currency = price.currency;
      if (currency) {
        const translatedCurrency = this.translate.instant('currency.' + currency);
        result += ` ${translatedCurrency}`;
      }

      const negotiable = price.negotiable;
      if (negotiable) {
        const translatedNegotiable = this.translate.instant('negotiable');
        result += ` (${translatedNegotiable})`;
      }
    }

    return result;
  }
}
